module.exports = __webpack_public_path__ + "img/cir-late.5364de79.svg";